import React from "react";

export const MessageContext = React.createContext({ sendMessage: () => {} });
